export const SALE_SET_INITIAL_STATE = 'SALE_SET_INITIAL_STATE';
export const SALE_FIND_ALL = 'SALE_FIND_ALL';
export const SALE_VIEW = 'SALE_VIEW';
